export const PAGE_SIZE_OPTIONS = ['10', '25', '50', '100'];

const DATE_TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

const normalizeText = (value) => String(value ?? '').trim();

export const formatAffectedDate = (value) => {
  if (!value) {
    return 'Unknown date';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return normalizeText(value) || 'Unknown date';
  }

  return DATE_TIME_FORMATTER.format(date);
};

export const normalizeRepoName = (value) => {
  const normalized = normalizeText(value);

  if (!normalized) {
    return 'Unknown repository';
  }

  const [project, repository] = normalized.split('|');

  return repository ? `${project} / ${repository}` : project;
};

export const normalizeAffectedFile = (item, index = 0) => ({
  key:
    item?.committed_item_id ??
    item?.rn ??
    `${normalizeText(item?.bug_id) || 'affected-file'}-${index + 1}`,
  bugId: normalizeText(item?.bug_id),
  bugUrl: normalizeText(item?.bug_url),
  filePath: normalizeText(item?.file_path),
  fileUrl: normalizeText(item?.file_url),
  repoName: normalizeRepoName(item?.repo_name),
  action: normalizeText(item?.action) || 'Unknown',
  author: normalizeText(item?.author) || 'Unknown',
  revision: normalizeText(item?.revision) || '--',
  commitDate: item?.commit_date ?? '',
  commitDateLabel: formatAffectedDate(item?.commit_date),
  raw: item,
});
